import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.list>>;

export const createFetchOrganizationsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getOrganizationsList({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
          includeExternallyManaged: params.includeExternallyManaged,
        }),
        signal,
      ),
    );
